import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { ClockIcon, MenuIcon, XIcon } from 'lucide-react';
const liens = [{
  to: '/',
  label: 'Accueil'
}, {
  to: '/modeles',
  label: 'Nos modèles'
}, {
  to: '/personnaliser',
  label: 'Personnaliser'
}];
export function Header() {
  const [ouvert, setOuvert] = useState(false);
  const location = useLocation();
  return <header className="sticky top-0 z-40 border-b border-line bg-parchment/95 backdrop-blur" data-id="element-105" data-mp="2rmxet7c4346c">
      <div className="mx-auto flex h-20 max-w-6xl items-center justify-between px-5" data-id="element-106" data-mp="2wkqh3paane1c">
        <Link to="/" className="flex items-center gap-3" onClick={() => setOuvert(false)} data-id="element-107" data-mp="31c8mcpjco0s4">
          <span className="flex h-11 w-11 items-center justify-center rounded-full border border-forest/25 text-forest" data-id="element-108" data-mp="36b1x4a795dol">
            <ClockIcon className="h-5 w-5" aria-hidden="true" data-id="element-109" data-mp="3baxs5jxz1us0" />
          </span>
          <span className="leading-tight" data-id="element-110" data-mp="3fbgmplr91exw">
            <span className="block font-display text-lg font-semibold tracking-tight text-ink" data-id="element-111" data-mp="3fcjedvweblev">
              Plaisir d'Offrir
            </span>
            <span className="block text-[11px] uppercase tracking-[0.22em] text-muted" data-id="element-112" data-mp="2rlrjbf2ihn0y">
              Horloges personnalisées
            </span>
          </span>
        </Link>

        <nav aria-label="Navigation principale" className="hidden items-center gap-8 md:flex" data-id="element-113" data-mp="2morawxi6w86o">
          {liens.map(lien => <NavLink key={lien.to} to={lien.to} className={({
          isActive
        }) => `text-sm transition-colors duration-150 ease-out hover:text-ink ${isActive ? 'text-ink' : 'text-muted'}`} data-id="element-114" data-mp="3fb2nz7mzg1kd">
              {lien.label}
            </NavLink>)}
          <Link to="/personnaliser" className="rounded-full bg-forest px-5 py-2.5 text-sm font-medium text-cream transition-colors duration-150 ease-out hover:bg-forest-dark" data-id="element-115" data-mp="30kd99vabc4br">
            Créer mon horloge
          </Link>
        </nav>

        <button type="button" onClick={() => setOuvert(v => !v)} aria-expanded={ouvert} aria-label={ouvert ? 'Fermer le menu' : 'Ouvrir le menu'} className="flex h-10 w-10 items-center justify-center rounded-full border border-line text-ink md:hidden" data-id="element-116" data-mp="1rew406xb27lv">
          {ouvert ? <XIcon className="h-5 w-5" data-id="element-117" data-mp="1mkrxforyc1lb" /> : <MenuIcon className="h-5 w-5" data-id="element-118" data-mp="18nbqmc5qu5t1" />}
        </button>
      </div>

      {ouvert && <div className="border-t border-line bg-parchment px-5 py-4 md:hidden" data-id="element-119" data-mp="1cooy0qohih22">
          <ul className="space-y-1" data-id="element-120" data-mp="1cmkj7dp1rxn0">
            {liens.map(lien => <li key={lien.to} data-id="element-121" data-mp="yqgs3t9h05er">
                <Link to={lien.to} onClick={() => setOuvert(false)} className={`block rounded-lg px-3 py-2.5 text-sm ${location.pathname === lien.to ? 'bg-cream text-ink' : 'text-muted'}`} data-id="element-122" data-mp="yr8m4znf5v2x">
                  {lien.label}
                </Link>
              </li>)}
          </ul>
        </div>}
    </header>;
}